module.exports = __webpack_public_path__ + "static/media/banner1.3980af9f.jpg";